export default {
  "pages.layouts.userLayout.title": "プロジェクト管理",
  "pages.login.pageTitle": "ログイン / 新規登録",
  "pages.login.success": "ログイン成功",
  "pages.login.failure": "ログイン失敗。もう一度お試しください",
  "pages.login.email.placeholder": "メールアドレス",
  "pages.login.email.required": "メールアドレスを入力してください",
  "pages.login.email.invalid": "有効なメールアドレスを入力してください",
  "pages.login.brandPitch":
    "プロジェクト・タスク・進捗を、チームのために一元管理。",
  "pages.login.heroTitle": "プロジェクトを、見える化する。\n遅れを、止める。",
  "pages.login.heroSubtitle":
    "ガント・WBSで進捗をひと目で把握。遅延・ブロック・期限間近のリスクを先回りで検知し、チーム全体の状況を一画面で。",
  "pages.login.slogan.1": "ガントチャートで、全体を俯瞰。",
  "pages.login.slogan.2": "WBSで、タスクを分解。",
  "pages.login.slogan.3": "遅れる前に、リスクを検知。",
  "pages.login.slogan.4": "依存関係も、進捗も、ひと目で。",
  "pages.login.line": "LINEで続ける",
  "pages.login.google": "Googleで続ける",
  "pages.login.or": "または",
  "pages.login.socialComingSoon": "{provider} ログインは近日公開予定です",
  "pages.login.privacy":
    "続行することで、<terms>利用規約</terms>と<privacy>プライバシーポリシー</privacy>に同意したものとみなされます。",
  "pages.login.openMailbox.gmail": "Gmail を開く ↗",
  "pages.login.openMailbox.yahooJp": "Yahoo!メールを開く ↗",
  "pages.login.openMailbox.yahoo": "Yahoo Mail を開く ↗",
  "pages.login.openMailbox.icloud": "iCloud メールを開く ↗",
  "pages.login.openMailbox.outlook": "Outlook を開く ↗",
  "pages.login.code.send": "メールで続ける",
  "pages.login.code.placeholder": "6桁の認証コード",
  "pages.login.code.required": "認証コードを入力してください",
  "pages.login.code.invalid": "6桁の数字を入力してください",
  "pages.login.code.sent": "認証コードを送信しました",
  "pages.login.code.sentTo":
    "以下に送信された認証コードを入力してください：{email}",
  "pages.login.code.sendFailed": "認証コードの送信に失敗しました",
  "pages.login.code.resendIn": "{seconds}秒後に再送信できます",
  "pages.login.code.resend": "認証コードを再送信",
  "pages.login.continue": "続ける",
  "pages.login.changeEmail": "← メールアドレスを変更",
  "pages.login.method.email": "メール",
  "pages.login.method.password": "アカウント・パスワード",
  "pages.login.username.placeholder": "ユーザー名またはメールアドレス",
  "pages.login.username.required":
    "ユーザー名またはメールアドレスを入力してください",
  "pages.login.password.placeholder": "パスワード",
  "pages.login.password.required": "パスワードを入力してください",
  "pages.login.password.submit": "ログイン",
  "pages.404.subTitle": "ページが見つかりません",
  "pages.404.buttonText": "ホームに戻る",
  "pages.502.title": "サーバーに接続できません",
  "pages.502.subTitle":
    "ただいまサーバーが応答していません。しばらくしてから再度お試しください。",
  "pages.502.buttonText": "再読み込み",
  "pages.oauth.title": "ログイン処理中",
  "pages.oauth.processing": "ログイン処理中…",
  "pages.oauth.success": "ログインしました",
  "pages.oauth.fetchUserFailed": "ユーザー情報の取得に失敗しました",
  "pages.oauth.backToLogin": "ログイン画面に戻る",
  "pages.oauth.error.stateMismatch":
    "認証情報が不正です。もう一度お試しください。",
  "pages.oauth.error.googleFailed":
    "Google 認証に失敗しました。もう一度お試しください。",
  "pages.oauth.error.disabled": "アカウントが無効化されています。",
  "pages.oauth.error.closing":
    "このアカウントは削除手続き中です。復旧はサポートにお問い合わせください。",
  "pages.oauth.error.generic":
    "ログインに失敗しました。時間を置いてもう一度お試しください。",

  // 共通
  "common.action": "操作",
  "common.edit": "編集",
  "common.delete": "削除",
  "common.cancel": "キャンセル",
  "common.confirm": "確認",
  "common.save": "保存",
  "common.created": "作成しました",
  "common.updated": "更新しました",
  "common.deleted": "削除しました",
  "common.createdAt": "作成日時",
  "common.reset": "リセット",
  "common.export": "エクスポート",
  "common.exporting": "エクスポート中...",
  "common.export.success": "エクスポート完了",
  "common.export.noData": "エクスポートするデータがありません",
  "common.import": "インポート",
  "common.upload": "クリックしてアップロード",

  // 設定
  "notifications.title": "お知らせ",
  "settings.tab.account": "アカウント設定",
  "settings.tab.security": "セキュリティ設定",
  "settings.account.info": "アカウント情報",
  "settings.account.username": "ユーザー名",
  "settings.account.tenant": "テナントID",
  "settings.account.userCode": "ユーザー番号",
  "settings.account.createdAt": "登録日時",
  "settings.account.displayName": "表示名",
  "settings.account.displayNamePlaceholder": "表示名を入力",
  "settings.account.displayNameHint":
    "設定すると、アカウント名の代わりに表示されます",
  "settings.account.save": "保存",
  "settings.account.displayNameSuccess": "表示名を更新しました",
  "settings.password.title": "パスワード変更",
  "settings.password.setTitle": "パスワードを設定",
  "settings.password.setHint":
    "メール / Google でログインしているため、まだパスワードが設定されていません。設定すると「メールアドレス + パスワード」でもログインできます。現在のパスワードは不要で、メール認証コードのみで設定できます。",
  "settings.password.setSubmit": "パスワードを設定",
  "settings.password.changeDesc":
    "メール認証コードで、新しいパスワードに変更できます。現在のパスワードの入力は不要です。",
  "settings.password.setSuccess":
    "パスワードを設定しました。メールアドレス + パスワードでログインできます",
  "settings.password.old": "現在のパスワード",
  "settings.password.new": "新しいパスワード",
  "settings.password.confirm": "新しいパスワード（確認）",
  "settings.password.minLength": "パスワードは6文字以上で入力してください",
  "settings.password.mismatch": "パスワードが一致しません",
  "settings.password.submit": "パスワードを変更",
  "settings.password.success": "パスワードを変更しました",
  "settings.password.code": "認証コード",
  "settings.password.codePlaceholder": "6桁の認証コード",
  "settings.password.sendCode": "認証コードを送信",
  "settings.password.codeResendIn": "{seconds}秒後に再送信",
  "settings.password.codeSent": "認証コードを送信しました",
  "settings.password.codeSentTo": "認証コードを {email} に送信します",
  "settings.password.codeInvalid": "6桁の数字を入力してください",
  "settings.tab.app": "アプリ設定",
  "settings.app.title": "アプリカスタマイズ",
  "settings.app.icon": "アプリアイコン",
  "settings.app.icon.desc":
    "モバイルアプリ用のカスタムアイコンをアップロードします。推奨：1024×1024 px の PNG 画像。",
  "settings.app.icon.upload": "アイコンをアップロード",
  "settings.app.icon.change": "アイコンを変更",
  "settings.app.icon.delete": "アイコンを削除",
  "settings.app.icon.deleteConfirm": "現在のアイコンを削除しますか？",
  "settings.app.icon.requirement": "PNG形式、正方形、512×512 px以上推奨",
  "settings.app.icon.success": "アイコンを更新しました",
  "settings.app.icon.deleteSuccess": "アイコンを削除しました",
  "settings.app.icon.sizeError":
    "画像は正方形で、512×512ピクセル以上である必要があります",

  // --- ログアウト ---
  "settings.account.logout": "ログアウト",
  "settings.account.logoutDesc":
    "現在のアカウントからログアウトします。次回は再度ログインが必要です。",
  "settings.account.logoutConfirmTitle": "ログアウトしますか？",

  // --- アカウント削除 ---
  "settings.account.dangerZone": "危険な操作",
  "settings.account.deleteAccount": "アカウントを削除",
  "settings.account.deleteAccountDesc":
    "削除後、アカウントは30日後に完全に削除されます。この期間中はいつでもログインしてアカウントを復元できます。",
  "settings.account.deleteConfirmTitle": "アカウント削除の確認",
  "settings.account.deleteConfirmDesc":
    "パスワードを入力して確認してください。削除後はログアウトされます。30日以内にログインしてアカウントを復元できます。",
  "settings.account.deleteConfirmPassword": "パスワードを入力",
  "settings.account.deleteConfirmEmailDesc":
    "削除を確認するため、アカウントのメールアドレス {email} を入力してください。削除後はログアウトされ、30日以内にログインして復元できます。",
  "settings.account.deleteConfirmEmailRequired":
    "メールアドレスを入力してください",
  "settings.account.deleteConfirmEmailMismatch":
    "メールアドレスがアカウントと一致しません",
  "settings.account.deleteDataNotice":
    "30日経過後、以下のデータは完全に削除され、復元できません",
  "settings.account.deleteDataItem.records": "入出庫記録",
  "settings.account.deleteDataItem.products": "商品情報",
  "settings.account.deleteDataItem.user": "アカウント情報",
  "settings.account.deleteSuccess": "アカウント削除リクエストが送信されました",

  // お知らせ
  "notice.tab.system": "お知らせ",
  "notice.tab.todo": "やること",
  "notice.empty": "お知らせはありません",
  "notice.todo.empty": "やることはありません",
  "notice.readAll": "すべて既読にする",
  "notice.markSelectedRead": "既読にする",
  "notice.selected": "{count} 件選択中",
  "notice.viewAll": "すべて表示",

  "notice.col.content": "メッセージ内容",
  "notice.col.time": "受信日時",
  "notice.col.type": "メッセージタイプ",
  "notice.type.notice": "お知らせ",
  "notice.type.announcement": "アナウンス",
  "notice.detail.title": "メッセージ詳細",
  "notice.pagination.total": "合計 {total} 件",

  // チーム招待
  "invitation.inbox.title": "招待リスト",
  "invitation.inbox.line":
    "{inviter} さんが「{team}」チームへの参加を招待しています",
  "invitation.inbox.expiresAt": "有効期限：{date}",
  "invitation.accept": "参加する",
  "invitation.decline": "辞退する",
  "invitation.declineConfirm": "この招待を辞退しますか？",
  "invitation.acceptSuccess":
    "「{team}」に参加しました。右上のチーム切替から確認できます",
  // 招待メールの深リンク受諾ページ
  "invitation.accept.pageTitle": "チームへの招待",
  "invitation.accept.loading": "招待内容を確認しています…",
  "invitation.accept.invalidTitle": "招待リンクが無効です",
  "invitation.accept.invalidDesc":
    "リンクが正しくないか、すでに失効しています。招待者に再送を依頼してください。",
  "invitation.accept.expiredTitle": "招待の有効期限が切れています",
  "invitation.accept.expiredDesc":
    "この招待は期限切れです。招待者に再送を依頼してください。",
  "invitation.accept.acceptedTitle": "受諾済みです",
  "invitation.accept.acceptedDesc": "この招待はすでに受諾されています。",
  "invitation.accept.closedTitle": "この招待は終了しています",
  "invitation.accept.declinedDesc": "この招待は辞退されました。",
  "invitation.accept.revokedDesc": "この招待は取り消されました。",
  "invitation.accept.loginToAccept": "ログインして参加する",
  "invitation.accept.later": "あとで",
  "invitation.accept.mismatchDesc":
    "招待先は {invited} 宛です。現在のアカウント（{current}）とは異なります。招待先のメールでログインしてください。",
  "invitation.accept.switchAccount": "別のアカウントでログイン",
  "invitation.accept.goApp": "システムへ",

  // 設定 - お知らせ

  // 設定 - チーム管理
  "settings.tab.team": "チーム管理",
  "settings.tab.holidays": "祝日管理",
  "settings.tab.workday": "工数設定",
  "settings.tab.mcp": "MCP設定",
  // 工数設定タブ（1営業日=何時間）
  "pages.workday.title": "1日の労働時間（工数換算）",
  "pages.workday.desc":
    "工期の「日数 ↔ 時間」を換算する単位です。1営業日 = 何時間として扱うかを設定します（既定 8h）。会社・プロジェクトにより 8h / 7.5h など異なる運用に合わせられます。",
  "pages.workday.label": "1営業日 =",
  "pages.workday.unit": "時間",
  "pages.workday.save": "保存",
  "pages.workday.saved": "工数設定を保存しました",
  "pages.workday.range": "1〜24 の範囲で入力してください",
  "pages.workday.teamHint":
    "この設定はワークスペース全体の工期表示に反映されます。",
  "pages.workday.ownerOnly": "この設定はオーナーのみ変更できます。",
  "pages.workday.note":
    "既存タスクの入力値（日数・時間）は変更されません。総工期や工数の「時間換算」の解釈のみが変わります。",
  "settings.mcp.title": "AI アシスタント連携（MCP）",
  "settings.mcp.intro":
    "この URL をあなたの ChatGPT / Claude に登録すると、チャットで話しかけるだけでこの PM システムを操作できます（タスクの閲覧・作成・更新など）。",
  "settings.mcp.urlLabel": "あなた専用の接続 URL",
  "settings.mcp.warning":
    "この URL はあなた個人の鍵です。他人に共有しないでください。漏れた場合は「URL を再発行」で無効化できます。",
  "settings.mcp.regenerate": "URL を再発行",
  "settings.mcp.regenerateConfirm":
    "再発行すると今の URL は使えなくなります。よろしいですか？",
  "settings.mcp.regenerated": "新しい URL を発行しました",
  "settings.mcp.setupTitle": "設定方法",
  "settings.mcp.claudeTitle": "Claude に登録する",
  "settings.mcp.chatgptTitle": "ChatGPT に登録する",
  "settings.mcp.cl1":
    "設定 → コネクタ を開く（「開発者 / ローカル MCP」ではありません）",
  "settings.mcp.cl2": "「カスタムコネクタを追加」→ 上の URL を貼り付け",
  "settings.mcp.cl3": "チャットで「PM アシスタント」を有効にして話しかける",
  "settings.mcp.cg1":
    "設定 → コネクタ → 詳細設定 で「開発者モード」を ON にする",
  "settings.mcp.cg2":
    "「カスタムコネクタを追加」→ 上の URL を貼り付け（認証：なし）",
  "settings.mcp.cg3": "チャットで「PM アシスタント」を選んで話しかける",
  "settings.mcp.example":
    "例：「〇〇プロジェクトの遅れているタスクを教えて」「この要件をタスクに分解して登録して」",
  "team.name.title": "ワークスペース名",
  "team.name.desc":
    "ワークスペース名はテナント名として、チーム切替などに表示されます。オーナーのみ変更できます。",
  "team.name.edit": "変更",
  "team.name.placeholder": "ワークスペース名を入力",
  "team.name.required": "ワークスペース名を入力してください",
  "team.name.success": "ワークスペース名を更新しました",
  "team.group.title": "チーム",
  "team.group.desc":
    "ワークスペース内に複数のチームを作成し、招待時に参加チームを指定できます（PROプラン）。メンバーは所属チームのプロジェクトのみ閲覧できます。",
  "team.group.create": "チームを追加",
  "team.group.editTitle": "チームを編集",
  "team.group.col.name": "チーム名",
  "team.group.col.members": "メンバー数",
  "team.group.default": "既定",
  "team.group.members": "メンバー",
  "team.group.membersTitle": "「{name}」のメンバー",
  "team.group.membersDesc":
    "このチームに所属させるメンバーを選択します。メンバーは複数チームに所属できます。",
  "team.group.membersPlaceholder": "メンバーを選択",
  "team.group.deleteConfirm":
    "チーム「{name}」を削除しますか？（先に配下のプロジェクトを移動／削除してください）",
  "team.group.nameRequired": "チーム名を入力してください",
  "team.invite.teams": "参加チーム",
  "team.invite.teams.tip":
    "承諾後、選択したチームに自動的に参加します（複数選択可）。",
  "team.invite.teamsRequired": "チームを1つ以上選択してください",
  "team.invite.teamsPlaceholder": "チームを選択",
  "team.title": "チームメンバー",
  "team.invite": "メンバーを招待",
  "team.invite.title": "新しいメンバーを招待",
  "team.invite.email": "メールアドレス",
  "team.invite.emailInvalid": "正しいメールアドレスを入力してください",
  "team.invite.displayName": "表示名（任意）",
  "team.invite.displayName.tip": "招待を受け入れた後、この名前で表示されます",
  "team.invite.message": "メッセージ（任意）",
  "team.invite.checking": "メールアドレスを確認中…",
  "team.invite.alreadyMember": "このメールアドレスはすでにチームメンバーです",
  "team.invite.alreadyPending":
    "このメールアドレスには未処理の招待があります。再送できます。",
  "team.invite.accountExists":
    "このメールはプロジェクト管理システムに登録済みです。承諾されるとメンバーとして参加します。",
  "team.invite.accountNew":
    "このメールでアカウントを作成してチームに参加します",
  "team.invite.success": "招待を送信しました",
  "team.invite.resend": "再送",
  "team.invite.resendSuccess": "招待を再送しました",
  "team.invite.revoke": "取り消し",
  "team.invite.revokeConfirm": "この招待を取り消しますか？",
  "team.invite.col.email": "メールアドレス",
  "team.invite.col.expiresAt": "有効期限",
  "team.invite.col.createdAt": "招待日時",
  "team.invitations.title": "未処理の招待",
  "teamSwitcher.title": "チームを切替",
  "lang.ja-JP": "日本語",
  "lang.en-US": "英語",
  "lang.zh-CN": "中国語（簡体字）",
  "lang.zh-TW": "中国語（繁体字）",
  "teamSwitcher.switched": "「{team}」に切り替えました",
  "team.col.displayName": "表示名",
  "team.col.username": "ユーザー名",
  "team.col.role": "ロール",
  "team.col.teams": "所属チーム",
  "team.allTeams": "全チーム",
  "team.col.status": "ステータス",
  "team.role.owner": "オーナー",
  "team.role.member": "メンバー",
  "team.status.active": "有効",
  "team.status.disabled": "無効",
  "team.status.invited": "招待中",
  "team.edit": "編集",
  "team.edit.success": "メンバー情報を更新しました",
  "team.remove": "削除",
  "team.remove.confirm":
    "このメンバーを削除しますか？削除後はログインできなくなります。",
  "team.disable": "無効化",
  "team.enable": "有効化",

  // チーム - 権限設定
  "team.permissions": "権限設定",
  "team.permissions.title": "権限を編集 - {name}",
  "team.permissions.selectAll": "すべて選択",
  "team.permissions.resetDefaults": "デフォルトに戻す",
  "team.permissions.resetDefaults.confirm": "デフォルトの権限に戻しますか？",
  "team.permissions.save.success": "権限設定を保存しました",
  "team.permissions.reset.success": "デフォルトの権限に戻しました",
  "team.permissions.custom": "カスタム",
  "team.permissions.default": "デフォルト",
  "team.permissions.col.category": "分類",
  "team.permissions.col.target": "操作対象",
  "team.permissions.col.permissions": "機能権限",
  "team.permissions.group.product": "商品管理",
  "team.permissions.group.contact": "取引先",
  "team.permissions.group.expense": "支出",
  "team.permissions.group.income": "収入",
  "team.permissions.group.analytics": "データ分析",
  "team.permissions.action.list": "閲覧",
  "team.permissions.action.add": "追加",
  "team.permissions.action.edit": "編集",
  "team.permissions.action.delete": "削除",
  "team.permissions.action.void": "取消",
  "team.permissions.action.export": "エクスポート",
  "team.permissions.action.view": "閲覧",
  "team.permissions.action.category": "カテゴリ管理",

  // 初回ログイン時のパスワード変更
  "changeInitialPassword.title": "初期パスワードの変更",
  "changeInitialPassword.hint":
    "アカウント保護のため、初期パスワードの変更をおすすめします",
  "changeInitialPassword.new": "新しいパスワード",
  "changeInitialPassword.confirm": "新しいパスワード（確認）",
  "changeInitialPassword.submit": "変更する",
  "changeInitialPassword.skip": "スキップして後で変更",
  "changeInitialPassword.success": "パスワードを変更しました",

  // PM 俯瞰ページ
  "overview.title": "俯瞰",
  "overview.subtitle":
    "プロジェクト横断で遅延・リスクを一目で把握し、早期に発見します",
  "overview.view.all": "全社俯瞰",
  "overview.view.member": "マイタスク",
  "overview.notMember":
    "このアカウントは PM メンバー未登録のため「マイタスク」を表示できません",
  "overview.kpi.activeProjects": "進行中案件",
  "overview.kpi.delayedProjects": "遅延案件",
  "overview.kpi.delayedTasks": "遅延タスク",
  "overview.kpi.blocked": "ブロック中",
  "overview.kpi.dueSoon": "今週の期日",
  "overview.kpi.unassigned": "未割当",
  "overview.stat.title": "タスクサマリー",
  "overview.stat.inProgress": "進行中タスク",
  "overview.stat.delayed": "遅延タスク",
  "overview.stat.delayed.tip": "クリックで遅延タスクのみ表示",
  "overview.stat.thisWeek": "今週のタスク",
  "overview.risk.title": "リスク一覧",
  "overview.risk.clearFilter": "フィルタ解除",
  "overview.risk.filter.delayed": "遅延タスクのみ",
  "overview.risk.empty": "遅延・リスクはありません 🎉",
  "overview.risk.col.kind": "リスク",
  "overview.risk.col.project": "顧客 / 案件",
  "overview.risk.col.task": "タスク",
  "overview.risk.col.taskProject": "タスク / 顧客・案件",
  "overview.risk.col.assignee": "担当",
  "overview.risk.col.due": "期日",
  "overview.risk.col.delay": "遅延",
  "overview.risk.col.progress": "進捗",
  "overview.kind.overdue": "期限超過",
  "overview.kind.behind": "進捗遅れ",
  "overview.kind.blocked": "依存ブロック",
  "overview.kind.due-soon": "期日接近",
  "overview.kind.unassigned": "未割当",
  "overview.delay.overdueDays": "{n}日超過",
  "overview.delay.dueInDays": "あと{n}日",
  "overview.delay.today": "本日",
  "overview.unassignedLabel": "未割当",
  "overview.health.title": "案件ヘルス",
  "overview.health.empty": "案件がありません",
  "overview.health.delayBadge": "遅延 {n}",
  "overview.assignee.title": "担当者別タスク分布",
  "overview.assignee.empty": "割当タスクがありません",
  "overview.assignee.unassigned": "未割当",
  "overview.assignee.tasksUnit": "{n} 件",
  "overview.milestone.title": "今週のマイルストーン",
  "overview.milestone.empty": "直近のマイルストーンなし",
  "overview.milestone.overdue": "{n}日超過",
  "overview.milestone.dueIn": "あと{n}日",
  "overview.my.kpi.open": "担当中タスク",
  "overview.my.kpi.delayed": "遅延",
  "overview.my.kpi.thisWeek": "今週の期日",
  "overview.my.kpi.bugs": "マイバグ（未完了）",
  "overview.my.kpi.bugsHigh": "高 {n}",
  "overview.my.count": "未完了 {n}件",
  "overview.my.countShort": "{n}件",
  "overview.my.noDue": "期日なし",
  "overview.my.tasks.title": "マイタスク",
  "overview.my.tasks.hint": "行クリックでガントへ",
  "overview.my.tasks.empty": "未完了の担当タスクはありません 🎉",
  "overview.my.bucket.overdue": "遅延",
  "overview.my.bucket.today": "今日",
  "overview.my.bucket.week": "今週",
  "overview.my.bucket.later": "来週以降",
  "overview.my.more": "残り {n}件を表示",
  "overview.my.show": "表示する",
  "overview.my.collapse": "折りたたむ",
  "overview.my.bugs.title": "マイバグ",
  "overview.my.bugs.viewAll": "すべて見る",
  "overview.my.bugs.empty": "未完了の担当バグはありません",
  "overview.my.bugs.age": "{n}日前",
  "overview.my.projects.title": "参加中の案件",
  "overview.my.milestones.title": "直近のマイルストーン",

  // PM カレンダー（個人 / 全社の月ビュー）
  "calendar.title": "カレンダー",
  "calendar.subtitle": "今日・今週やるべきタスクを一目で",
  "calendar.view.all": "全社俯瞰",
  "calendar.view.member": "マイビュー",
  "calendar.notMember":
    "このアカウントは PM メンバー未登録のため「マイビュー」を表示できません",
  "calendar.empty": "該当タスクなし",
  "calendar.today": "今日",
  "calendar.filter.all": "すべて",
  "calendar.filter.task": "タスク",
  "calendar.filter.event": "イベント",
  "calendar.fullscreen": "全画面",
  "calendar.fullscreenExit": "全画面解除",

  // イベント / 会議日程（カレンダー内）
  "event.legend": "イベント種別",
  "event.type.meeting": "会議",
  "event.type.review": "レビュー",
  "event.type.milestone": "マイルストーン",
  "event.type.deadline": "納期",
  "event.type.other": "その他",
  "event.new": "新規イベント",
  "event.edit": "イベント編集",
  "event.field.title": "タイトル",
  "event.field.type": "種別",
  "event.field.start": "開始",
  "event.field.end": "終了",
  "event.field.allDay": "終日",
  "event.field.project": "案件",
  "event.field.task": "関連タスク",
  "event.field.attendees": "参加者",
  "event.field.location": "場所",
  "event.field.note": "メモ",
  "event.field.projectGlobal": "グローバル（案件なし）",
  "event.save": "保存",
  "event.cancel": "キャンセル",
  "event.delete": "削除",
  "event.deleteConfirm": "このイベントを削除しますか？",
  "event.saved": "保存しました",
  "event.deleted": "削除しました",
  "event.validate.title": "タイトルを入力してください",
  "event.validate.time": "開始日時を選択してください",
  "event.validate.endBeforeStart": "終了日時は開始日時より前にできません",

  // PM プロジェクト管理
  "projects.title": "プロジェクト管理",
  "projects.subtitle":
    "顧客 / 製品ごとにプロジェクトを整理し、進捗を追跡します",
  "projects.create": "プロジェクト作成",
  "projects.count": "{count} 件のプロジェクト",
  "projects.searchPlaceholder": "プロジェクトを検索…",
  "projects.filter.all": "全て",
  "projects.filter.placeholder": "名前・説明で絞り込む",
  "projects.filter.emptyKw": "「{kw}」に一致するプロジェクトはこの顧客配下にありません",
  "projects.filter.bridge": "「{kw}」をタスク・バグでも検索",
  "projects.status.all": "すべての状態",
  "projects.status.planned": "未着手",
  "projects.status.active": "進行中",
  "projects.status.paused": "一時停止",
  "projects.status.done": "納品済み",
  "projects.selectCustomerFirst": "まず左側で顧客 / 製品を選択してください",
  "projects.noMatch": "一致するプロジェクトがありません",
  "projects.emptyHint":
    "この顧客にはまだプロジェクトがありません。「プロジェクト作成」から始めましょう",
  "projects.card.edit": "プロジェクトを編集",
  "projects.card.delete": "プロジェクトを削除",
  "projects.card.noDesc": "説明なし",
  "projects.card.enter": "開く",
  "projects.card.overdue": "期限超過",
  "projects.col.progress": "進捗",
  "projects.col.actions": "操作",
  "projects.reordered": "並び順を更新しました",
  "projects.drag.hint": "ドラッグして並び替え",
  "projects.drag.disabled": "並び替えるには検索・絞り込みを解除してください",
  "projects.customers.title": "顧客 / 製品",
  "projects.customers.new": "顧客 / 製品を追加",
  "projects.customers.searchPlaceholder": "顧客を検索…",
  "projects.customers.empty": "顧客がありません",
  "projects.customers.count": "{count} 件",
  "projects.customers.avg": "進捗 {avg}%",
  "projects.customers.collapse": "リストを折りたたむ",
  "projects.customers.expand": "リストを展開",
  "projects.delete.title": "プロジェクトを削除",
  "projects.delete.content":
    "「{customer} {name}」を削除してもよろしいですか？このプロジェクト配下のすべてのタスクと依存関係も削除され、元に戻せません。",
  "projects.delete.ok": "削除",
  "projects.deleted": "プロジェクトを削除しました",
  "projects.form.createTitle": "プロジェクト作成",
  "projects.form.editTitle": "プロジェクトを編集",
  "projects.form.create": "作成",
  "projects.form.save": "保存",
  "projects.form.customer": "顧客 / 製品",
  "projects.form.customerRequired": "顧客を選択してください",
  "projects.form.customerPlaceholder": "顧客を選択",
  "projects.form.name": "プロジェクト名",
  "projects.form.nameRequired":
    "プロジェクト名を入力してください（例：v1.0.0）",
  "projects.form.namePlaceholder": "v1.0.0",
  "projects.form.description": "説明",
  "projects.form.descriptionPlaceholder": "今回の主な内容…",
  "projects.form.status": "状態",
  "projects.form.statusRequired": "状態を選択してください",
  // ===== 種別（通常プロジェクト / 運用・保守） =====
  "projects.form.kind": "種別",
  "projects.form.kindRequired": "種別を選択してください",
  "projects.form.kindTip":
    "運用・保守は依頼が随時追加されスコープが動くため、達成率ではなく件数で管理します",
  "projects.kind.project": "通常プロジェクト",
  "projects.kind.projectDesc": "範囲が決まっている案件。進捗率で管理",
  "projects.kind.ops": "運用・保守",
  "projects.kind.opsDesc": "改修依頼が随時入る継続案件。件数で管理",
  "projects.form.endRequired": "終了日を選択してください",
  "projects.form.endOptional": "空のままにすると「継続中」になります",
  "projects.form.startPlaceholder": "開始日",
  "projects.form.endPlaceholder": "終了日",
  "projects.form.endOngoing": "継続中（未定）",
  "projects.card.ongoing": "継続中",
  "projects.ops.thisMonth": "今月 {done}/{total} 件完了",
  "projects.ops.open": "未完了 {count} 件",
  // ===== 月次工数枠（保守契約の「月◯人日まで」） =====
  "projects.form.quota": "月次工数枠",
  "projects.form.quotaTip":
    "保守契約の「月◯人日まで」。設定すると一覧に今月の消化状況が出ます",
  "projects.form.quotaOptional": "空欄なら枠なし（件数だけ表示）",
  "projects.form.quotaUnit": "人日 / 月",
  "projects.form.quotaPlaceholder": "例：20",
  "projects.ops.quotaActual": "実績 {used} / {quota}",
  "projects.ops.quotaPlanned": "予定 {used} / {quota}",
  "projects.ops.quotaOver": "枠超過",
  "projects.ops.quotaTooltip": "今月 予定 {planned} · 実績 {actual} · 枠 {quota}",
  "projects.form.range": "期間",
  "projects.form.rangeRequired": "期間を選択してください",
  "projects.updated": "プロジェクトを更新しました",
  "projects.created": "プロジェクトを作成しました",
  "projects.cancel": "キャンセル",
  "projects.customer.created": "顧客を作成しました",
  "projects.customer.createTitle": "顧客 / 製品を追加",
  "projects.customer.name": "名称（顧客 / 製品）",
  "projects.customer.nameRequired": "名称を入力してください（例：東邦銀行）",
  "projects.customer.namePlaceholder": "例：東邦銀行 / 受発注システム",
  "projects.customer.shortName": "略称",
  "projects.customer.shortNamePlaceholder": "任意、例：東邦 / 受発注",
  "projects.customer.team": "所属チーム",
  "projects.customer.teamRequired": "チームを選択してください",
  "projects.customer.teamPlaceholder": "チームを選択",
  "projects.customer.create": "作成",
  // ===== ガントページ タブ =====
  "projects.gantt.tab.wbs": "WBS",
  "projects.gantt.tab.board": "ボード",
  "projects.gantt.tab.roadmap": "スケジュール",
  "projects.gantt.tab.design": "デザインボード",
  // ===== ボード（看板）ビュー =====
  "projects.board.status.backlog": "バックログ",
  "projects.board.status.todo": "未着手",
  "projects.board.status.inProgress": "進行中",
  "projects.board.status.testing": "テスト",
  "projects.board.status.done": "完了",
  "projects.board.status.cancelled": "中止",
  "projects.board.empty": "ボードに表示できるタスクがありません",
  // ===== 右ペイン：ビュー切替 / 年度スケジュール =====
  "projects.view.list": "バージョン一覧",
  "projects.view.annual": "年度スケジュール",
  "projects.annual.newVersion": "新バージョン",
  "projects.annual.empty": "{year}年に該当するバージョンがありません",
  "projects.annual.release": "リリース",
  "projects.annual.today": "今日",
  // ===== ガント：WBS ヘッダー / 行操作 / ツールバー =====
  "projects.gantt.col.name": "タスク名",
  "projects.gantt.col.start": "開始日",
  "projects.gantt.col.duration": "工期",
  "projects.gantt.col.progress": "進捗",
  "projects.gantt.col.people": "担当",
  "projects.gantt.row.addChild": "サブタスク追加",
  "projects.gantt.row.edit": "編集",
  "projects.gantt.row.delete": "削除",
  "projects.gantt.scale.day": "日",
  "projects.gantt.scale.week": "週",
  "projects.gantt.expandAll": "すべて展開",
  "projects.gantt.collapseAll": "すべて折りたたむ",
  // ツールバーの実表示は短縮形。全体に効くことは title 属性の長い文言で補う
  "projects.gantt.expandAllShort": "展開",
  "projects.gantt.collapseAllShort": "折りたたむ",
  "projects.gantt.addTask": "タスク追加",
  "projects.gantt.empty.desc":
    "タスクがありません。「タスク追加」をクリックしてスケジュールを開始しましょう",
  "projects.gantt.notFound": "プロジェクトが見つかりません",
  "projects.gantt.deleteTask.title": "「{name}」を削除しますか？",
  "projects.gantt.deleteTask.summary":
    "このタスク配下のすべての子タスクと関連する依存関係も削除されます。",
  "projects.gantt.deleteTask.leaf": "関連する依存関係の線も削除されます。",
  // ===== ロードマップ（導入スケジュール）ビュー =====
  // dayjs 月份格式（时间轴表头）
  "projects.roadmap.monthFormat": "M月",
  "projects.roadmap.empty": "ロードマップに表示する項目がありません",
  "projects.roadmap.lane.milestone": "マイルストーン",
  "projects.roadmap.lane.system": "システム",
  "projects.roadmap.lane.business": "業務",
  "projects.roadmap.lane.default": "その他",
  "projects.roadmap.party.client": "貴社作業",
  "projects.roadmap.party.vendor": "弊社作業",
  "projects.roadmap.legend.client": "貴社作業",
  "projects.roadmap.legend.vendor": "弊社作業",
  "projects.roadmap.msColor.critical": "重要（赤）",
  "projects.roadmap.msColor.normal": "通常（グレー）",
  "projects.roadmap.msColor.client": "貴社（緑）",
  "projects.roadmap.msColor.vendor": "弊社（青）",
  "projects.roadmap.optionManager.entry": "レーン管理",
  "projects.roadmap.optionManager.title": "レーン・マイルストーン色の管理",
  "projects.roadmap.optionManager.teamHint": "変更はチーム全体に反映されます",
  "projects.roadmap.optionManager.laneSection": "レーン",
  "projects.roadmap.optionManager.msColorSection": "マイルストーン色",
  "projects.roadmap.optionManager.addLane": "レーンを追加",
  "projects.roadmap.optionManager.addMsColor": "色を追加",
  "projects.roadmap.optionManager.namePlaceholder": "名称を入力",
  "projects.roadmap.optionManager.system": "標準",
  "projects.roadmap.optionManager.deleteConfirm": "削除しますか？",
  "projects.roadmap.optionManager.nameRequired": "名称を入力してください",
  // ===== タスク編集：基本情報 =====
  "projects.taskForm.title.add": "タスクを追加",
  "projects.taskForm.title.edit": "タスクを編集",
  "projects.taskForm.title.child": "「{name}」配下にサブタスクを追加",
  "projects.taskForm.name": "タスク名",
  "projects.taskForm.nameRequired": "タスク名を入力してください",
  "projects.taskForm.namePlaceholder": "例：詳細設計_S0390_画面",
  "projects.taskForm.type": "種別",
  "projects.taskForm.type.task": "通常タスク",
  "projects.taskForm.type.summary": "サマリー（フェーズ）",
  "projects.taskForm.type.milestone": "マイルストーン",
  "projects.taskForm.project": "所属プロジェクト（フェーズ）",
  "projects.taskForm.projectHint":
    "別のプロジェクトに変更すると、このタスクと配下のサブタスクをまとめて移動します。プロジェクトをまたぐ依存線は解除されます。",
  "projects.taskForm.projectPlaceholder": "所属プロジェクトを選択",
  "projects.taskForm.parent": "上位タスク（親フェーズ）",
  "projects.taskForm.parentHint":
    "選択したプロジェクト内のサマリー（フェーズ）配下に配置します。空欄＝最上位。",
  "projects.taskForm.parentRoot": "最上位（フェーズに紐付けない）",
  "projects.taskForm.derivedHint":
    "サマリー（フェーズ）の期間・進捗は配下の子タスクから自動集計されるため、直接編集できません。子タスク側を編集してください。",
  "projects.taskForm.summaryRangeOptionalHint":
    "空欄可：子タスクを追加すると期間は自動集計されます。空欄のうちは所属プロジェクトの期間で暫定表示します。",
  "projects.taskForm.milestoneDate": "予定マイルストーン日",
  "projects.taskForm.planRange": "予定期間",
  "projects.taskForm.rangeRequired": "予定期間を選択してください",
  "projects.taskForm.rangeOutOfProject":
    "予定期間はプロジェクト期間（{start} ～ {end}）内に収めてください",
  "projects.taskForm.actualRange": "実績期間（未着手は空欄・開始のみで着手中）",
  "projects.taskForm.actualStartRequired":
    "終了日を入力する場合は開始日も必須です",
  "projects.taskForm.actualEndBeforeStart":
    "実績終了日は開始日より前にできません",
  "projects.taskForm.effort": "工期（日数＋時間）",
  "projects.taskForm.effortPlan": "予定工期（日数＋時間）",
  "projects.taskForm.effortActual": "実績工期（日数＋時間）",
  "projects.taskForm.effortTip":
    "工期は日数d＋時間h（0〜23.75、小数0.25刻み可）で直接入力できます。空欄なら期間（営業日 × 1日の労働時間）から自動算出。下の[使う]で目安値を流し込めます",
  "projects.taskForm.effortSuffix": "時間",
  "projects.taskForm.effortDaysSuffix": "日",
  "projects.taskForm.effortUse": "使う",
  "projects.taskForm.effortHint":
    "{days}d（{days}営業日 ≈ {hours}h｜1日 {hpd}h）",
  "projects.taskForm.effortManualBadge": "手動設定",
  "projects.taskForm.effortAutoBadge": "期間から自動（{dur}）",
  "projects.taskForm.levels": "ラベル（複数可、Enterで追加）",
  "projects.taskForm.levelsPlaceholder":
    "ラベルを入力してEnter、例：重要 / 難 / フロント",
  "projects.taskForm.progress": "進捗",
  "projects.taskForm.status": "ステータス",
  "projects.taskForm.assignee": "担当者",
  "projects.taskForm.assigneePlaceholder": "担当者を選択",
  "projects.taskForm.description": "説明（画像貼り付け可）",
  "projects.taskForm.descriptionPlaceholder":
    "タスクの説明を入力。スクリーンショットの貼り付け / ドラッグ＆ドロップ可…",
  // ===== タスク編集：ロードマップ設定 =====
  // ===== タスクコメント =====
  "projects.comments.title": "コメント",
  "projects.comments.empty": "まだコメントはありません",
  "projects.comments.placeholder": "コメントを入力（⌘/Ctrl+Enter で送信）",
  "projects.comments.send": "送信",
  "projects.comments.emoji": "絵文字",
  "projects.comments.edited": "編集済み",
  "projects.comments.deleteConfirm": "このコメントを削除しますか？",
  // ===== タスク操作履歴（ドロワー右カラム「操作履歴」タブ） =====
  "projects.activity.title": "操作履歴",
  "projects.activity.empty": "まだ操作履歴はありません",
  "projects.activity.emptyHint": "タスクを編集すると自動で記録されます",
  "projects.activity.noneInFilter": "この条件に該当する履歴はありません",
  "projects.activity.today": "今日",
  "projects.activity.none": "未設定",
  "projects.activity.ongoing": "未定",
  "projects.activity.autoEffort": "期間から自動",
  "projects.activity.showFull": "全文を表示",
  "projects.activity.collapse": "折りたたむ",
  "projects.activity.filter.all": "すべての操作",
  "projects.activity.filter.progress": "ステータス・進捗",
  "projects.activity.filter.schedule": "日程・工期",
  "projects.activity.filter.people": "担当者・ラベル",
  "projects.activity.filter.other": "説明・その他",
  "projects.activity.action.created": "が このタスクを作成",
  "projects.activity.action.updated": "が {count} 件のフィールドを変更",
  "projects.activity.action.updatedOne": "が {field} を変更",
  "projects.activity.action.childAdded": "が サブタスク を追加",
  "projects.activity.action.childRemoved": "が サブタスク を削除",
  "projects.activity.action.depAdded": "が 依存関係 を追加",
  "projects.activity.action.depRemoved": "が 依存関係 を解除",
  "projects.activity.field.name": "タスク名",
  "projects.activity.field.type": "種別",
  "projects.activity.field.status": "ステータス",
  "projects.activity.field.progress": "進捗",
  "projects.activity.field.planRange": "予定期間",
  "projects.activity.field.actualRange": "実績期間",
  "projects.activity.field.plannedEffort": "予定工期",
  "projects.activity.field.actualEffort": "実績工期",
  "projects.activity.field.assignees": "担当者",
  "projects.activity.field.levels": "ラベル",
  "projects.activity.field.description": "説明",
  "projects.activity.field.parent": "上位タスク",
  "projects.activity.field.project": "所属プロジェクト",
  "projects.activity.field.roadmapVisible": "ロードマップ",
  "projects.activity.field.roadmapLane": "レーン",
  "projects.activity.field.ownerParty": "作業区分",
  "projects.activity.field.milestoneColor": "マイルストーン色",
  "projects.activity.field.subtask": "サブタスク",
  "projects.activity.field.predecessor": "先行タスク",
  "projects.activity.field.successor": "後続タスク",
  "projects.activity.value.shown": "表示",
  "projects.activity.value.hidden": "非表示",
  // ===== タスク編集：関連リンク（デザイン / Figma） =====
  "projects.links.title": "デザイン",
  "projects.links.empty": "関連デザインはまだありません",
  "projects.links.urlPlaceholder": "Figma リンクを貼り付け（他の URL も可）",
  "projects.links.titlePlaceholder": "ラベル（任意、例「ログイン画面 v2」）",
  "projects.links.add": "追加",
  "projects.links.figmaHint":
    "Figma は「リンクを知っている全員が閲覧可」に設定すると埋め込み表示できます",
  "projects.links.open": "新しいタブで開く",
  "projects.links.deleteConfirm": "このリンクを削除しますか？",
  // ===== タスク編集：ロードマップ設定 =====
  "projects.taskForm.roadmap.panel": "ロードマップ設定",
  "projects.taskForm.roadmap.visible": "ロードマップに表示",
  "projects.taskForm.roadmap.lane": "レーン",
  "projects.taskForm.roadmap.lanePlaceholder": "レーンを選択",
  "projects.taskForm.roadmap.ownerParty": "作業区分",
  "projects.taskForm.roadmap.milestoneColor": "マイルストーン色",
  "projects.taskForm.roadmap.milestoneColorPlaceholder": "色を選択",

  // ===== リソース（メンバー）ビュー =====
  "resources.title": "リソース",
  "resources.subtitle":
    "メンバーごとの担当タスクを横断的に俯瞰し、稼働の重なりを検知します",
  "resources.mode.single": "個人",
  "resources.mode.all": "全員",
  "resources.scale.day": "日",
  "resources.scale.week": "週",
  "resources.year.auto": "自動",
  "resources.range.start": "開始月",
  "resources.range.end": "終了月",
  "resources.hideCompleted": "完了タスクを非表示",
  "resources.member.placeholder": "メンバーを選択",
  "resources.member.empty": "メンバーがいません",
  "resources.selectMemberFirst": "まずメンバーを選択してください",
  "resources.empty": "担当タスクがありません",
  "resources.allEmpty": "担当のあるタスクがありません",
  "resources.loading": "読み込み中…",
  "resources.view.timeline": "タイムライン",
  "resources.view.list": "リスト",
  "resources.list.total": "全 {n} 件",
  "resources.col.task": "タスク",
  "resources.col.project": "プロジェクト",
  "resources.col.assignee": "担当",
  "resources.col.plan": "予定",
  "resources.col.actual": "実績",
  "resources.col.progress": "進捗",
  "resources.conflict.badge": "稼働重複",
  "resources.conflict.tip":
    "{count} 件のタスクで期間が重複しています（同時に複数案件を担当）",
  "resources.conflict.legend": "稼働重複",
  "resources.noSchedule": "（期間未設定）",
  "resources.backToAll": "全員ビューに戻る",
  "resources.openDetail": "このメンバーの詳細を見る",
  "resources.editTask": "タスクを編集",

  // ===== 工時実績サマリー（個人モード） =====
  "resources.stats.title": "工時実績サマリー",
  "resources.stats.note": "完了タスクを含む",
  "resources.stats.hpd": "1営業日={hpd}h",
  "resources.stats.hint":
    "担当関与ベースで集計しています（複数担当のタスクは各担当者に全工数を計上するため、合算は重複します）。工期は 1営業日={hpd}h 換算。",
  "resources.stats.collapse": "折りたたむ",
  "resources.stats.expand": "展開",
  "resources.stats.empty": "この期間に担当タスクがありません",
  "resources.stats.kpi.actual": "実績合計工数",
  "resources.stats.kpi.planned": "予定合計工数",
  "resources.stats.kpi.tasks": "稼働タスク数",
  "resources.stats.kpi.rate": "消化率",
  "resources.stats.kpi.unit": "件",
  "resources.stats.kpi.target": "対象 {n}件",
  "resources.stats.kpi.done": "完了 {n}",
  "resources.stats.kpi.wip": "進行 {n}",
  "resources.stats.kpi.remain": "残 {v}",
  "resources.stats.kpi.over": "超過 {v}",
  "resources.stats.kpi.noPlan": "予定なし",
  "resources.stats.kpi.noPlanShort": "予定なし",
  "resources.stats.kpi.rateHint": "実績 / 予定",
  "resources.stats.export.btn": "Excel 出力",
  "resources.stats.export.sheet1": "概要",
  "resources.stats.export.sheet2": "タスク一覧",
  "resources.stats.export.member": "メンバー",
  "resources.stats.export.period": "期間",
  "resources.stats.export.allPeriod": "全期間",
  "resources.stats.export.metric": "指標",
  "resources.stats.export.value": "値",
  "resources.stats.export.delta": "予定差",
  "resources.stats.export.doneLabel": "完了タスク数",
  "resources.stats.export.wipLabel": "進行中タスク数",
  "resources.stats.export.col.name": "タスク名",
  "resources.stats.export.col.customer": "顧客",
  "resources.stats.export.col.status": "ステータス",
  "resources.stats.export.col.planStart": "予定開始",
  "resources.stats.export.col.planEnd": "予定終了",
  "resources.stats.export.col.actualStart": "実績開始",
  "resources.stats.export.col.actualEnd": "実績終了",
  "resources.stats.export.status.done": "完了",
  "resources.stats.export.status.ongoing": "着手中",
  "resources.stats.export.status.wip": "進行中",
  "resources.stats.export.status.todo": "未着手",

  // ===== PM 顧客 / 製品ページ =====
  "customers.title": "顧客 / 製品",
  "customers.subtitle": "顧客と製品を管理し、プロジェクトの所属先とします",
  "customers.new": "顧客を新規作成",
  "customers.create": "作成",
  "customers.search.placeholder": "名称 / 略称を検索…",
  "customers.count": "顧客 / 製品 {count} 件",
  "customers.col.name": "名称",
  "customers.col.shortName": "略称",
  "customers.col.projectCount": "プロジェクト数",
  "customers.col.createdAt": "作成日",
  "customers.empty":
    "顧客がまだありません。「顧客を新規作成」から追加してください",
  "customers.edit": "顧客を編集",
  "customers.delete.title": "「{name}」を削除しますか？",
  "customers.delete.hasProjects":
    "この顧客には {count} 件のプロジェクトがあります。削除すると所属先が失われます。",
  "customers.delete.irreversible": "削除すると元に戻せません。",
  "customers.msg.saved": "保存しました",
  "customers.msg.created": "顧客を作成しました",
  "customers.form.name": "名称（顧客 / 製品）",
  "customers.form.name.required": "名称を入力してください（例：東邦銀行）",
  "customers.form.name.placeholder": "例：東邦銀行 / 受発注システム",
  "customers.form.shortName": "略称",
  "customers.form.shortName.placeholder": "任意。例：東邦 / 受発注",
  "customers.col.status": "状態",
  "customers.status.active": "有効",
  "customers.status.inactive": "無効",
  "customers.form.active": "状態",
  "customers.form.active.tip":
    "無効にすると、この顧客はアーカイブ扱いになります",

  // ===== PM リッチテキストエディタ =====
  "pm.rte.uploading": "画像をアップロード中…",
  "pm.rte.uploadFailed": "画像のアップロードに失敗しました",
  "pm.rte.bold": "太字",
  "pm.rte.italic": "斜体",
  "pm.rte.underline": "下線",
  "pm.rte.strike": "取り消し線",
  "pm.rte.bulletList": "箇条書き",
  "pm.rte.orderedList": "番号付きリスト",
  "pm.rte.alignLeft": "左揃え",
  "pm.rte.alignCenter": "中央揃え",
  "pm.rte.alignRight": "右揃え",
  "pm.rte.insertImage": "画像を挿入",
  "pm.rte.imgSmall": "画像：小",
  "pm.rte.imgMedium": "画像：中",
  "pm.rte.imgFull": "画像：フル幅",
  "pm.rte.hint": "画像を直接貼り付け / ドラッグできます",
  "pm.rte.placeholder": "タスクの説明を入力（画像を貼り付け可）…",

  // ===== PM ガントチャート · 実績 =====
  "gantt.actual.ongoing": "実績 {start}~ 進行中（未完了）",
  "gantt.actual.range": "実績 {start}~{end}（{dur}）",
  "gantt.tip.planEffort": "予定工期",
  "gantt.tip.actualEffort": "実績工期",
  "gantt.foot.total": "総工期",
  "gantt.foot.planned": "予定",
  "gantt.foot.actual": "実績",
  "gantt.foot.note": "※ 1日 = {hpd}時間で換算",

  // ===== PM マインドマップ（Mind Map） =====
  "mindmap.title": "マインドマップ",
  "mindmap.empty": "マインドマップがありません。新規作成しましょう",
  "mindmap.noProject": "プロジェクト未関連",
  "mindmap.updatedAt": "更新 {time}",
  "mindmap.notFound": "マインドマップが存在しないか削除されました",
  "mindmap.act.new": "新規作成",
  "mindmap.act.editInfo": "情報を編集",
  "mindmap.act.delete": "削除",
  "mindmap.act.back": "戻る",
  "mindmap.act.addChild": "子ノード追加 (Tab)",
  "mindmap.act.addSibling": "兄弟ノード追加 (Enter)",
  "mindmap.act.nodeColor": "ノードの色",
  "mindmap.act.collapseAll": "すべて折りたたむ",
  "mindmap.act.expandAll": "すべて展開",
  "mindmap.act.zoomIn": "拡大",
  "mindmap.act.zoomOut": "縮小",
  "mindmap.act.fit": "画面に合わせる",
  "mindmap.act.exportPng": "PNG 書き出し",
  "mindmap.act.reload": "再読み込み",
  "mindmap.field.name": "名称",
  "mindmap.field.nameRequired": "名称を入力してください",
  "mindmap.field.namePlaceholder": "例：プロダクト企画マップ",
  "mindmap.field.project": "関連プロジェクト（任意）",
  "mindmap.field.projectPlaceholder": "プロジェクトを選択",
  "mindmap.msg.created": "作成しました",
  "mindmap.msg.updated": "更新しました",
  "mindmap.msg.deleted": "削除しました",
  "mindmap.msg.confirmDelete": "「{name}」を削除しますか？",
  "mindmap.save.saved": "保存済み",
  "mindmap.save.dirty": "未保存…",
  "mindmap.save.saving": "保存中…",
  "mindmap.save.error": "保存失敗",
  "mindmap.save.conflict": "他のユーザーが更新しました",
  "mindmap.theme.classic": "クラシック",
  "mindmap.theme.dark": "ダーク",
  "mindmap.theme.forest": "フォレスト",
  "mindmap.theme.sunset": "サンセット",
  "mindmap.tip.rootUndeletable": "中心テーマは削除できません",
  "mindmap.hint.keys":
    "Tab 子 · Enter 兄弟 · ダブルクリックで編集 · Delete 削除 · Ctrl/⌘+ホイールで拡大縮小",

  // 祝日管理
  "pages.holidays.title": "祝日",
  "pages.holidays.teamHint":
    "祝日はテナント全体で共有され、変更はチーム全員に反映されます。工期と進捗は土日とこれらの祝日を自動的に除外します。",
  "pages.holidays.syncNow": "今すぐ同期",
  "pages.holidays.syncSuccess":
    "同期完了：追加 {added}・更新 {updated}・削除 {removed}",
  "pages.holidays.add": "追加",
  "pages.holidays.import": "一括インポート",
  "pages.holidays.yearAll": "全年",
  "pages.holidays.col.date": "日付",
  "pages.holidays.col.name": "名称",
  "pages.holidays.col.source": "ソース",
  "pages.holidays.col.action": "操作",
  "pages.holidays.source.manual": "手動",
  "pages.holidays.source.synced": "同期",
  "pages.holidays.edit": "編集",
  "pages.holidays.delete": "削除",
  "pages.holidays.deleteConfirm": "この祝日を削除しますか？",
  "pages.holidays.empty":
    "祝日がありません。「今すぐ同期」で holidays-jp から取得するか、手動で追加してください。",
  "pages.holidays.saved": "保存しました",
  "pages.holidays.addTitle": "祝日を追加",
  "pages.holidays.editTitle": "祝日を編集",
  "pages.holidays.form.date": "日付",
  "pages.holidays.form.dateRequired": "日付を選択してください",
  "pages.holidays.form.name": "名称",
  "pages.holidays.form.nameRequired": "名称を入力してください",
  "pages.holidays.form.namePlaceholder": "例：元日",
  "pages.holidays.importTitle": "祝日を一括インポート",
  "pages.holidays.importHint":
    "1行に1件：YYYY-MM-DD 名称（カンマ / タブ / スペース区切り）。既存の日付はスキップされます。",
  "pages.holidays.importEmpty": "インポートできる有効な行がありません",
  "pages.holidays.importResult": "{added} 件をインポートしました",

  // ===== 品質管理（Quality）=====
  "quality.title": "品質管理",
  "quality.subtitle": "テストケースの管理・実施記録とバグ票の管理",
  "quality.selectProject": "プロジェクトを選択",
  "quality.noProject": "表示できるプロジェクトがありません",
  "quality.tab.cases": "テストケース",
  "quality.tab.bugs": "バグ管理",
  "quality.suite.title": "スイート",
  "quality.suite.all": "すべて",
  "quality.suite.add": "スイート追加",
  "quality.suite.edit": "スイート編集",
  "quality.suite.name": "スイート名",
  "quality.suite.prefix": "採番接頭辞（例：STU）",
  "quality.suite.description": "説明",
  "quality.suite.deleteConfirm": "このスイートと配下のケースを削除しますか？",
  "quality.suite.empty":
    "スイートがありません。「スイート追加」から作成してください。",
  "quality.category.normal": "正常系",
  "quality.category.abnormal": "異常系",
  "quality.category.boundary": "境界値",
  "quality.result.pass": "OK",
  "quality.result.fail": "NG",
  "quality.result.na": "対象外",
  "quality.result.untested": "未実施",
  "quality.priority.high": "高",
  "quality.priority.medium": "中",
  "quality.priority.low": "低",
  "quality.severity.high": "高",
  "quality.severity.medium": "中",
  "quality.severity.low": "低",
  "quality.bugStatus.open": "未対応",
  "quality.bugStatus.inProgress": "対応中",
  "quality.bugStatus.resolved": "修正済",
  "quality.bugStatus.verifying": "確認中",
  "quality.bugStatus.closed": "完了",
  "quality.bugStatus.wontfix": "対応せず",
  "quality.case.no": "ID",
  "quality.case.title": "テスト観点",
  "quality.case.feature": "機能",
  "quality.case.category": "区分",
  "quality.case.priority": "優先度",
  "quality.case.result": "実施結果",
  "quality.case.assignee": "担当者",
  "quality.case.task": "タスク",
  "quality.case.actions": "操作",
  "quality.case.add": "ケース追加",
  "quality.case.edit": "ケース編集",
  "quality.case.deleteConfirm": "このケースを削除しますか？",
  "quality.case.precondition": "前提条件",
  "quality.case.steps": "テスト手順",
  "quality.case.testData": "テストデータ",
  "quality.case.expected": "期待結果",
  "quality.case.remark": "備考",
  "quality.case.raiseBug": "バグ起票",
  "quality.case.batchResult": "実施結果を一括記録",
  "quality.case.selectedN": "{n} 件選択中",
  "quality.case.searchPlaceholder": "観点・大機能・IDで検索",
  "quality.case.filterResult": "実施結果",
  "quality.case.filterCategory": "区分",
  "quality.case.filterPriority": "優先度",
  "quality.case.filterAssignee": "担当者",
  "quality.case.filterFeature": "機能",
  "quality.case.empty": "ケースがありません",
  "quality.case.linkTask": "タスクに紐付け",
  "quality.suite.linkTask": "タスクに紐付け（任意）",
  "quality.case.unlinkTask": "紐付け解除",
  "quality.case.notLinked": "未紐付け",
  "quality.bug.no": "ID",
  "quality.bug.title": "タイトル",
  "quality.bug.severity": "影響度",
  "quality.bug.priority": "優先度",
  "quality.bug.status": "状態",
  "quality.bug.assignee": "担当者",
  "quality.bug.reporter": "報告者",
  "quality.bug.task": "タスク",
  "quality.bug.noTask": "該当タスクなし",
  "quality.bug.noDescription": "説明はありません。",
  "quality.bug.batchLinkN": "選択{n}件をタスクに紐付け",
  "quality.bug.batchLinkedN": "{n}件を紐付けました",
  "quality.bug.batchUnlink": "紐付け解除",
  "quality.bug.batchUnlinkConfirm": "選択{n}件のタスク紐付けを解除しますか？",
  "quality.bug.linkExisting": "既存バグを紐付け",
  "quality.bug.linkExistingHint":
    "このタスクに紐付ける既存バグを選択してください。",
  "quality.bug.selectBugs": "バグを選択",
  "quality.bug.project": "製品/プロジェクト",
  "quality.bug.wholeProduct": "（製品全体）",
  "quality.bug.selectProduct": "製品またはプロジェクトを選択してください",
  "quality.bug.movedTo": "「{product}」へ移動しました（採番し直し）",
  "quality.bug.createdAt": "起票日時",
  "quality.bug.reportedOn": "起票日",
  "quality.bug.resolvedAt": "完了日",
  "quality.bug.testCase": "発生ケース",
  "quality.bug.actions": "操作",
  "quality.bug.add": "バグ起票",
  "quality.bug.detail": "詳細",
  "quality.bug.edit": "編集",
  "quality.bug.deleteConfirm": "このバグ票を削除しますか？",
  "quality.bug.description": "内容（再現手順/期待/実際）",
  "quality.bug.environment": "環境",
  "quality.bug.reopenCount": "再オープン {n} 回",
  "quality.bug.filterStatus": "状態",
  "quality.bug.filterSeverity": "影響度",
  "quality.bug.filterPriority": "優先度",
  "quality.bug.filterAssignee": "担当者",
  "quality.bug.reportedFrom": "起票日 From",
  "quality.bug.reportedTo": "起票日 To",
  "quality.bug.resolvedFrom": "完了日 From",
  "quality.bug.resolvedTo": "完了日 To",
  "quality.bug.empty": "バグ票がありません",
  "quality.bug.fromCase": "ケース {caseNo} から起票",
  "quality.bug.tabCount": "未完了 {active} / 全 {total}",
  "quality.bug.statusActive": "未完了",
  "quality.bug.overview.active": "未完了",
  "quality.bug.overview.highSeverity": "影響度・高",
  "quality.bug.overview.oldest": "最古の未完了",
  "quality.bug.overview.days": "日",
  "quality.bug.overview.thisWeek": "今週：起票 +{reported} ／ 完了 {resolved}",
  "quality.bug.searchPlaceholder": "ID・タイトル・説明で検索",
  "quality.bug.filterProject": "プロジェクト",
  "quality.bug.wholeProductShort": "製品全体",
  "quality.bug.advancedFilter": "詳細フィルタ",
  "quality.bug.filterTask": "タスク紐付け",
  "quality.bug.taskLinked": "あり",
  "quality.bug.taskUnlinked": "なし",
  "quality.bug.clearFilters": "条件をクリア",
  "quality.bug.export": "エクスポート",
  "quality.bug.settings": "設定",
  "quality.bug.columns": "表示列",
  "quality.bug.ageDays": "{n}日経過",
  "quality.bug.more": "その他の操作",
  "quality.bug.duplicate": "複製して起票",
  "quality.bug.copyLink": "リンクをコピー",
  "quality.bug.linkCopied": "リンクをコピーしました",
  "quality.bug.selectedN": "{n}件選択中",
  "quality.bug.batchStatus": "状態を変更",
  "quality.bug.batchAssignee": "担当者を変更",
  "quality.bug.batchLink": "タスクに紐付け",
  "quality.bug.batchDeleteConfirm": "選択した{n}件のバグ票を削除しますか？",
  "quality.bug.clearSelection": "選択解除",
  "quality.bug.pageTotal": "{total} 件中 {start}–{end} 件",
  "quality.bug.chip.reported": "起票日：{v}",
  "quality.bug.chip.resolved": "完了日：{v}",
  "quality.bug.chip.task": "タスク紐付け：{v}",
  "quality.bug.chip.reporter": "報告者：{v}",
  "quality.bug.chip.environment": "環境：{v}",
  "quality.bug.reopenCountHeader": "再オープン回数",
  "quality.bug.resolvedAtHint": "状態を「修正済」「完了」にすると自動で記録されます",
  "quality.common.undo": "元に戻す",
  "quality.msg.undone": "元に戻しました",
  "quality.common.save": "保存",
  "quality.common.cancel": "キャンセル",
  "quality.common.all": "すべて",
  "quality.common.unassigned": "未割当",
  "quality.common.openGantt": "ガントで開く",
  "quality.common.delete": "削除",
  "quality.common.add": "追加",
  "quality.common.close": "閉じる",
  "quality.common.actions": "操作",
  "quality.env.manage": "環境マスタ",
  "quality.env.select": "環境を選択",
  "quality.env.empty": "環境が未登録です",
  "quality.env.emptyForProduct": "この製品の環境が未登録です",
  "quality.env.name": "区分",
  "quality.env.browser": "端末/ブラウザ",
  "quality.env.url": "URL",
  "quality.env.namePlaceholder": "dev / stg / prod",
  "quality.env.browserPlaceholder": "Chrome / iOS Safari",
  "quality.env.urlPlaceholder": "https://dev.example.jp",
  "quality.env.deleteConfirm": "この環境を削除しますか？",
  "quality.msg.saved": "保存しました",
  "quality.msg.deleted": "削除しました",
  "quality.msg.resultUpdated": "実施結果を更新しました",
  "quality.msg.batchDone": "{n} 件を更新しました",
  "quality.msg.bugRaised": "バグ票 {bugNo} を起票しました",
  "quality.msg.statusUpdated": "状態を更新しました",
  "quality.msg.selectCases": "ケースを選択してください",
  "quality.summary.execution": "消化率",
  "quality.task.openInQuality": "品質管理で開く",

  // タスク横断検索（コマンドパレット ⌘K）
  "search.entry": "検索",
  "search.placeholder": "タスク・案件・バグを検索",
  "search.hint": "タスク名・案件名・顧客名・バグ番号で検索できます",
  "search.empty": "「{kw}」に一致するものはありません",
  "search.kind.all": "すべて",
  "search.kind.task": "タスク",
  "search.kind.project": "案件",
  "search.kind.bug": "バグ",
  "search.overdueDays": "{n}日超過",
  "search.openTasks": "未完了 {n} 件",
  "search.foot.move": "移動",
  "search.foot.open": "開く",
  "search.foot.openProject": "案件を開く",

  // WBS / ボード内のキーワード絞り込み（案件を跨ぐ検索は ⌘K パレット側）
  "projects.gantt.filter.placeholder": "タスク名で絞り込み",
  "projects.gantt.filter.hits": "{n} 件",
  "projects.gantt.filter.empty": "「{kw}」に一致するタスクはありません",
  "projects.gantt.filter.clear": "絞り込みを解除",

  // 資料（外部ドライブのリンク：顧客 / 案件 / タスク）。設計 doc/design/pm-drive-docs.md
  "docs.title": "資料",
  "docs.projectButton": "案件資料 ({n})",
  "docs.add": "資料を追加",
  "docs.linkToTask": "資料を紐付け",
  "docs.open": "新しいタブで開く",
  "docs.empty": "登録された資料はまだありません",
  "docs.filterEmpty": "条件に一致する資料はありません",
  "docs.unlinkedEmpty": "タスクに未紐付けの資料はありません",
  "docs.taskEmpty": "このタスクに紐付いた資料はありません",
  "docs.selectToPreview": "資料を選択すると、ここにプレビューが表示されます",
  "docs.deleteConfirm": "「{name}」の登録を解除しますか？",
  "docs.deleteConfirm.desc": "ドライブ上のファイルは削除されません。PM 上の登録とタスクの紐付けだけを解除します。",
  "docs.remove": "登録解除",
  "docs.unlinkConfirm": "このタスクとの紐付けを外しますか？",
  "docs.unlink": "紐付けを外す",
  "docs.linkTasks": "タスクに紐付け",
  "docs.linkTasks.title": "紐付けるタスク",
  "docs.linkTasks.note": "選択したタスクで紐付けを置き換えます。空にすると未紐付けになります。",
  "docs.common": "顧客共通",
  "docs.projectWide": "案件全体",
  "docs.unlinked": "未紐付け",
  "docs.addedBy": "追加者 {name}",
  "docs.group.project": "案件",
  "docs.provider.google": "Google ドライブ",
  "docs.provider.microsoft": "SharePoint",
  "docs.provider.box": "Box",
  "docs.provider.other": "リンク",
  "docs.kind.gdoc": "Google ドキュメント",
  "docs.kind.gsheet": "Google スプレッドシート",
  "docs.kind.gslide": "Google スライド",
  "docs.kind.gfile": "ファイル",
  "docs.kind.gfolder": "フォルダ",
  "docs.kind.ms": "Microsoft 365 のファイル",
  "docs.kind.box": "Box のファイル",
  "docs.kind.link": "外部リンク",
  "docs.type.all": "すべての種類",
  "docs.type.pdf": "PDF",
  "docs.type.xls": "表計算",
  "docs.type.doc": "文書",
  "docs.type.ppt": "スライド",
  "docs.type.img": "画像",
  "docs.type.folder": "フォルダ",
  "docs.type.file": "その他のファイル",
  "docs.type.link": "リンク",
  "docs.preview.hint": "表示されない場合は、閲覧権限がない・別のアカウントでログインしている・ブラウザが埋め込みをブロックしている可能性があります。",
  "docs.fallback.title": "この資料はプレビューできません",
  "docs.fallback.google": "URL から Google ドライブのファイル ID を読み取れませんでした。ファイルの共有リンクで登録し直すとプレビューできる場合があります。",
  "docs.fallback.microsoft": "SharePoint / OneDrive の資料は、現在リンクでの参照のみに対応しています。新しいタブで開いてご確認ください。",
  "docs.fallback.box": "Box の資料は、現在リンクでの参照のみに対応しています。新しいタブで開いてご確認ください。",
  "docs.fallback.other": "外部サイトへのリンクです。新しいタブで開いてご確認ください。",
  "docs.root.customer": "顧客ルートフォルダ",
  "docs.root.project": "案件フォルダ",
  "docs.root.unsetCustomer": "顧客のルートフォルダが未設定です",
  "docs.root.unsetProject": "案件フォルダが未設定です",
  "docs.root.unsetHint": "Google ドライブのフォルダを設定すると、中身をここから閲覧できます",
  "docs.root.set": "フォルダを設定",
  "docs.root.change": "変更",
  "docs.root.remove": "設定を解除",
  "docs.drawer.stats": "案件 {projects} 件・資料 {docs} 件",
  "docs.root.bannerHint": "ファイルは顧客のドライブに保管されたまま。PM はリンクと紐付けだけを保存し、閲覧権限はドライブ側の共有設定に従います。",
  "docs.root.openFolder": "ルートフォルダを開く",
  "docs.root.removeConfirm": "フォルダの設定を解除しますか？",
  "docs.view.registered": "登録済み資料 ({n})",
  "docs.view.unlinked": "未紐付け ({n})",
  "docs.folder.registerHint": "このフォルダのファイルは、右上の「資料を追加」から登録するとここでプレビューでき、タスクにも紐付けられます",
  "docs.form.url.folder": "フォルダは資料として登録できません。ルートフォルダ（案件フォルダ）に設定するか、中のファイルを登録してください",
  "docs.search.placeholder": "名前・URL・タスク名で検索",
  "docs.col.name": "名前",
  "docs.col.provider": "保存先",
  "docs.col.target": "紐付け先",
  "docs.col.createdAt": "追加日",
  "docs.drawer.customer": "顧客資料",
  "docs.drawer.project": "案件資料",
  "docs.form.addTitle": "資料を追加",
  "docs.form.rootTitle": "フォルダを設定",
  "docs.form.mode.new": "URL から登録",
  "docs.form.mode.existing": "登録済みから選ぶ",
  "docs.form.url": "共有リンク（URL）",
  "docs.form.url.placeholder": "Google ドライブ・SharePoint・Box などの共有リンクを貼り付け",
  "docs.form.url.rootPlaceholder": "Google ドライブのフォルダの共有リンクを貼り付け",
  "docs.form.url.extra": "ファイルはドライブに置いたままです。閲覧権限はドライブ側の共有設定に従います。",
  "docs.form.url.rootExtra": "既存のフォルダ設定がある場合は置き換わります。",
  "docs.form.url.required": "URL を入力してください",
  "docs.form.url.invalid": "http:// または https:// で始まる URL（2000 文字以内）を入力してください",
  "docs.form.title": "表示名",
  "docs.form.title.placeholder": "任意（未入力の場合はファイル名やドメインを表示）",
  "docs.form.scope": "紐付け先",
  "docs.form.scope.task": "タスク",
  "docs.form.project": "案件",
  "docs.form.project.required": "案件を選択してください",
  "docs.form.tasks": "タスク",
  "docs.form.tasks.placeholder": "タスクを選択（WBS のパスで検索できます）",
  "docs.form.tasks.required": "タスクを 1 件以上選択してください",
  "docs.form.existing": "資料",
  "docs.form.existing.placeholder": "この案件に登録済みの資料を選択",
  "docs.form.existing.required": "資料を 1 件以上選択してください",
  "docs.hint.preview": "{kind} として認識しました（プレビュー可）",
  "docs.hint.linkOnly": "{provider} のリンクとして登録します（プレビューなし・新しいタブで開きます）",
  "docs.msg.added": "資料を追加しました",
  "docs.msg.linked": "紐付けました",
  "docs.msg.removed": "登録を解除しました",
  // Google Picker（第二步）。設計 doc/design/pm-drive-docs.md §7
  "docs.msg.addedN": "{n} 件の資料を追加しました",
  "docs.emptyWithFolder": "右上の「資料を追加」から、ルートフォルダ内のファイルを選んで登録できます。登録した資料はここでプレビューでき、タスクにも紐付けられます",
  "docs.defaultName.folder.google": "Google ドライブのフォルダ",
  "docs.defaultName.folder.microsoft": "SharePoint のフォルダ",
  "docs.defaultName.folder.box": "Box のフォルダ",
  "docs.defaultName.folder.other": "共有フォルダ",
  "docs.defaultName.gfile": "Google ドライブのファイル",
  "docs.chip.all": "すべて",
  "docs.chip.pdf": "PDF",
  "docs.chip.xls": "Excel",
  "docs.chip.doc": "Word",
  "docs.chip.ppt": "PowerPoint",
  "docs.chip.img": "画像",
  "docs.chip.folder": "フォルダ",
  "docs.form.mode.google": "Google ドライブから選択",
  "docs.form.mode.googleFolder": "Google ドライブから選択",
  "docs.picker.title": "PM に登録する資料を選択",
  "docs.picker.titleFolder": "フォルダを選択",
  "docs.picker.view.thisFolder": "このフォルダ",
  "docs.picker.view.myDrive": "マイドライブ",
  "docs.picker.view.sharedDrives": "共有ドライブ",
  "docs.picker.disabled": "Google ドライブ連携が設定されていません",
  "docs.picker.disabled.desc": "管理者が Google Picker（API キー・OAuth クライアント）を設定すると、ドライブから直接ファイルを選べるようになります。それまでは「URL から登録」をご利用ください。",
  "docs.picker.pick": "Google ドライブからファイルを選択",
  "docs.picker.pickMore": "さらに選択",
  "docs.picker.pickFolder": "Google ドライブからフォルダを選択",
  "docs.picker.repickFolder": "別のフォルダを選び直す",
  "docs.picker.removeItem": "選択から外す",
  "docs.picker.note": "フォルダを選ぶと、中のファイルをまとめて追加します。ファイルはドライブに置いたままで、閲覧権限はドライブ側の共有設定に従います。",
  "docs.picker.required": "ファイルを 1 件以上選択してください",
  "docs.picker.titleInFolder": "「{name}」のファイルを選択",
  "docs.picker.expanded": "「{name}」から {n} 件を追加しました",
  "docs.picker.skipDup": "登録済みの {n} 件は除きました",
  "docs.picker.importFiles": "フォルダ内のファイルも資料としてまとめて登録する",
  "docs.msg.rootImported": "ルートフォルダを設定し、ファイル {n} 件を登録しました",
  "docs.picker.addN": "{n} 件を追加",
  "docs.picker.err.config": "Google ドライブ連携の設定を取得できませんでした。時間をおいて再度お試しください。",
  "docs.picker.err.load": "Google のスクリプトを読み込めませんでした。ネットワーク接続や、広告・トラッキングをブロックする拡張機能をご確認ください。",
  "docs.picker.err.popup": "Google のログイン画面を開けませんでした。ブラウザのポップアップブロックを解除して、もう一度お試しください。",
  "docs.picker.err.auth": "Google の認可に失敗しました。時間をおいて再度お試しいただくか、管理者にお問い合わせください。",
  "docs.picker.err.scope": "ドライブへのアクセスが許可されませんでした。同意画面で Google ドライブの項目にチェックを入れてください。",
};
